import { formGroup, formArray, formControl, FormDataType } from '@core/utils/form';
import { CourseBuilder } from '../Blocks/types';
import { FontResponse } from '@business/entities/google';

export function defineCourseBuilderBlockForm() {
  return formGroup({
    id: formControl<string>({ initialValue: '0' }),
    title: formControl<string | undefined>({ label: 'Block Title', placeholder: 'Block Title' }),
    isSection: formControl<boolean>({ initialValue: false }),
    type: formControl<CourseBuilder.BlockType>({ placeholder: 'Block Type' }),
    variation: formControl<string>({ placeholder: 'Block Variation' }),
    menuOrder: formControl<number>({ initialValue: 0 }),

    data: formControl<any>({ placeholder: 'Block Data' }),
  });
}

export function defineCourseBuilderForm() {
  return formGroup({
    title: formControl<string>({ label: 'Title', initialValue: 'Lesson Title' }),
    font: formControl<FontResponse>({ label: 'Font (Google Font)', placeholder: 'Search Google Fonts...' }),
    primaryColor: formControl<string>({ label: 'Primary Color', initialValue: '#45A8F7' }),
    headingFontSize: formControl<number>({ label: 'Default Heading Font Size', initialValue: 35 }),
    fontSize: formControl<number>({ label: 'Default Paragraph Font Size', initialValue: 20 }),
    blocks: formArray(() => defineCourseBuilderBlockForm()),
    background: formControl<string>({ label: 'Background Color', initialValue: '' }),
    fontWeight: formControl<string>({ label: 'Default Font Weight' }),
  });
}

export type CourseBuilderForm = ReturnType<typeof defineCourseBuilderForm>;
export type CourseBuilderBlockForm = ReturnType<typeof defineCourseBuilderBlockForm>;

export type CourseBuilderFormData = FormDataType<typeof defineCourseBuilderForm>;
export type CourseBuilderBlockFormData = FormDataType<typeof defineCourseBuilderBlockForm>;
